export default "__VITE_ASSET__DmkdUDcX__"